import { Buttons, FlexContainer } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { FRONT_PLANS } from 'Constants/plans';
import { FilingSubmitProps } from './types';

const FLEX_CONTEXT = 'isFlex';
const EXTENDED_CONTEXT = 'isExtended';

const FilingSubmit = ({
  handleSubmit,
  buttonLabel,
  disabled,
  returnType,
  userPlan,
  renderOmmitButton,
}: FilingSubmitProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);

  const tContext =
    userPlan === FRONT_PLANS.FLEX
      ? FLEX_CONTEXT
      : returnType === TaxReturnTypes.EQUAL
        ? EXTENDED_CONTEXT
        : '';

  return (
    <FlexContainer direction="column" gap="dimension_16" justify="center" align="center">
      {!renderOmmitButton && returnType === TaxReturnTypes.EQUAL && (
        <Buttons.Tiny
          label={t('Filing.notReturn.ommit', { context: tContext })}
          onClick={handleSubmit}
        />
      )}
      <Buttons.Classic
        mode="primary"
        size="m"
        disabled={disabled}
        onClick={handleSubmit}
        label={t(buttonLabel)}
      />
    </FlexContainer>
  );
};

export default FilingSubmit;
